import React from "react";
import { getStore } from "Pub/js/storageUtils";
import platform from "Pub/js/platform";
import defaultIcon from "Pub/js/defaultIcon";
const { appIcons } = platform;
const AppIcon = ({ appCode, iconName }) => {
	let iconType = getStore("nccIcon") || "";
	iconType = iconType.length ? iconType + "_" : iconType;
	if (!iconName) {
		let AppIconStore = getStore("APPICONSSTORE");
		iconName = AppIconStore && AppIconStore[appCode];
	}
	let icon =
		appIcons && appIcons[iconType + iconName]
			? appIcons[iconType + iconName]
			: defaultIcon[iconType]
			? defaultIcon[iconType]
			: defaultIcon["defaultIcon"];
	return (
		<div
			style={{
				width: "24px",
				height: "24px",
				marginRight: "10px",
				background: `url(${icon}) no-repeat 0px 0px`,
				backgroundSize: "contain"
			}}
		/>
	);
};

export default AppIcon;

